'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fieldReducer = exports.reducers = exports.submitReducer = exports.saveProgressReducer = exports.saveReducer = exports.setVal = exports.set = exports.savedReducer = exports.openReducer = exports.dragLeaveReducer = exports.dragEnterReducer = exports.focusReducer = exports.errorReducer = exports.applyError = exports.closeReducer = exports.blurReducer = exports.getDragCount = exports.defaultState = undefined;

var _gte2 = require('lodash/fp/gte');

var _gte3 = _interopRequireDefault(_gte2);

var _property2 = require('lodash/property');

var _property3 = _interopRequireDefault(_property2);

var _isArray2 = require('lodash/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _flow2 = require('lodash/flow');

var _flow3 = _interopRequireDefault(_flow2);

var _reducers;

exports.asImmutable = asImmutable;
exports.default = reducer;

var _seamlessImmutable = require('seamless-immutable');

var _seamlessImmutable2 = _interopRequireDefault(_seamlessImmutable);

var _capeLodash = require('cape-lodash');

var _capeRedux = require('cape-redux');

var _actions = require('./actions');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // Only keeping state we can not calculate. See derivedState().


var defaultState = exports.defaultState = (0, _seamlessImmutable2.default)({
  blur: false,
  // When true the field is open but does not have focus.
  dragCount: 0,
  // For keeping track of entering children but maintaining focus.
  error: null,
  // String usually. Could be object for more complex error.
  focus: false,
  // When true the field is open and it has focus.
  id: null,
  // String. Used as a unique key/id for this specific field value.
  initialValue: null,
  // Anything.
  invalid: {},
  // index of invalid values.
  meta: null,
  // Anything.
  savedProgress: 0,
  // Percentage Number 0-99.
  savedValue: null,
  isSaving: false,
  // Bool.
  isTouched: false,
  valid: {},
  // index of valid values.
  value: null
});
var getDragCount = exports.getDragCount = (0, _property3.default)('dragCount');

var blurReducer = exports.blurReducer = function blurReducer(state, payload) {
  return state.merge({
    blur: true,
    dragCount: 0,
    focus: false,
    isTouched: true,
    value: payload || state.value
  });
};

var closeReducer = exports.closeReducer = function closeReducer(state) {
  return state.merge({
    blur: defaultState.blur,
    focus: defaultState.focus,
    isTouched: true
  });
};

var applyError = exports.applyError = function applyError(state, payload) {
  return state.merge({
    error: payload,
    isTouched: true
  });
};

var errorReducer = exports.errorReducer = function errorReducer(state, payload) {
  if (payload.error && payload.value) {
    return blurReducer(applyError(state, payload.error), payload.value);
  }

  return applyError(state, payload);
};

var focusReducer = exports.focusReducer = function focusReducer(state) {
  return state.merge({
    blur: false,
    focus: true,
    isTouched: true
  });
};

var dragEnterReducer = exports.dragEnterReducer = (0, _flow3.default)(focusReducer, function (state) {
  return state.set('dragCount', state.dragCount + 1);
});
var dragLeaveReducer = exports.dragLeaveReducer = (0, _flow3.default)(function (state) {
  return state.set('dragCount', state.dragCount - 1);
}, (0, _capeLodash.condId)([(0, _flow3.default)(getDragCount, (0, _gte3.default)(0)), blurReducer]));

var openReducer = exports.openReducer = function openReducer(state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return state.merge({
    focus: true,
    id: payload.id || defaultState.id,
    initialValue: state.initialValue || payload.initialValue || null,
    isTouched: true,
    value: state.value || payload.initialValue || null
  });
};

var savedReducer = exports.savedReducer = function savedReducer(state, payload) {
  return state.merge({
    error: defaultState.error,
    id: (0, _get3.default)(payload, 'id', state.id),
    isSaving: defaultState.isSaving,
    savedProgress: defaultState.savedProgress,
    savedValue: (0, _get3.default)(payload, 'value', state.value)
  });
};

var set = exports.set = function set(fieldId) {
  return function (state, payload) {
    return state.set(fieldId, payload);
  };
};

var setVal = exports.setVal = function setVal(fieldId, value) {
  return function (state) {
    return state.set(fieldId, value);
  };
};

var saveReducer = exports.saveReducer = setVal('isSaving', true);
var saveProgressReducer = exports.saveProgressReducer = (0, _flow3.default)(set('savedProgress'), saveReducer);

var submitReducer = exports.submitReducer = function submitReducer(state, payload) {
  return state.merge({
    blur: defaultState.blur,
    error: defaultState.error,
    focus: defaultState.focus,
    isSaving: true,
    value: payload || state.value
  });
};

var reducers = exports.reducers = (_reducers = {}, _defineProperty(_reducers, _actions.CLEAR, function () {
  return defaultState;
}), _defineProperty(_reducers, _actions.CLEAR_ERROR, function (state) {
  return state.set('error', defaultState.error);
}), _defineProperty(_reducers, _actions.CLOSE, closeReducer), _defineProperty(_reducers, _actions.ERROR, errorReducer), _defineProperty(_reducers, _actions.INVALID, function (state, payload) {
  return state.setIn(['invalid', payload.key], payload.value);
}), _defineProperty(_reducers, _actions.META, function (state, payload) {
  return state.merge({
    meta: payload,
    isTouched: true
  }, {
    deep: true
  });
}), _defineProperty(_reducers, _actions.OPEN, openReducer), _defineProperty(_reducers, _actions.SAVE, saveReducer), _defineProperty(_reducers, _actions.SAVED_PROGRESS, saveProgressReducer), _defineProperty(_reducers, _actions.SAVED, savedReducer), _defineProperty(_reducers, _actions.VALID, function (state, payload) {
  return state.setIn(['valid', payload.key], payload.value);
}), _defineProperty(_reducers, _actions.BLUR, blurReducer), _defineProperty(_reducers, _actions.CHANGE, function (state, payload) {
  return state.merge({
    isTouched: true,
    value: payload
  });
}), _defineProperty(_reducers, _actions.DRAG_ENTER, dragEnterReducer), _defineProperty(_reducers, _actions.DRAG_LEAVE, dragLeaveReducer), _defineProperty(_reducers, _actions.FOCUS, focusReducer), _defineProperty(_reducers, _actions.SUBMIT, submitReducer), _reducers);
var options = {
  makeImmutable: true,
  skipErrors: false
};
var fieldReducer = exports.fieldReducer = (0, _capeRedux.createReducer)(reducers, defaultState, options);

function asImmutable(state) {
  return state.asMutable ? state : (0, _seamlessImmutable2.default)(state);
}

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _seamlessImmutable2.default)({});
  var action = arguments[1];
  if ((0, _capeRedux.noReducerOfType)(reducers)(action)) return state;
  if (!(0, _isArray3.default)(action.meta.prefix)) throw new Error('Action must contain meta.prefix array.'); // Get the state slice we need for this action.

  var oldFieldState = (0, _get3.default)(state, action.meta.prefix);
  var newFieldState = fieldReducer(oldFieldState, action);
  if (oldFieldState === newFieldState) return state;
  return asImmutable(state).setIn(action.meta.prefix, newFieldState);
}